import { createRESTConn } from "../../../Common";
import { ConnectionNames } from "../../../Contracts";
import { CasinoPlayerActivityAPIRequestFormatter } from "../CasinoPlayerActivityAPIRequestFormatter";
import { CasinoPlayerActivityAPIResponseFormatter } from "../CasinoPlayerActivityAPIResponseFormatter";
export function createCasinoPlayerActivityConnection() {
    return createRESTConn({
        name: ConnectionNames.casinoPlayerActivity,
        handlers: {
            requestFormatter: CasinoPlayerActivityAPIRequestFormatter,
            responseFormatter: CasinoPlayerActivityAPIResponseFormatter
        }
    });
}
//# sourceMappingURL=CreateCasinoPlayerActivityAPIConnection.js.map